import { IStore } from './core/interface/IStore'
import store from './store/index'
import { ISysConsoleModule } from '@/contracts/system-modules/console/ISysConsoleModule'
import { EnumConsoleType } from '@/contracts/system-modules/console/enum/EnumConsoleType'
import ConsoleRecord from '@/system-modules/console/v1/core/entity/ConsoleRecord'

class ConsoleV1 implements ISysConsoleModule {
  private static instance: ISysConsoleModule
  private store: IStore = store()

  init(): boolean {
    this.log('Console module initialized', EnumConsoleType.SUCCESS)
    return true
  }

  static getInstance(): ISysConsoleModule {
    if (!ConsoleV1.instance) {
      ConsoleV1.instance = new ConsoleV1()
    }
    return ConsoleV1.instance
  }

  getLogs(): ConsoleRecord[] {
    return this.store.records as ConsoleRecord[]
  }

  isOpen(): boolean {
    return this.store.opened
  }

  log(message: string, type: EnumConsoleType = EnumConsoleType.INFO, vars: object[] = []): void {
    this.store.records.push(
      new ConsoleRecord(
        type,
        message,
        vars,
      ),
    )
  }

  show(): void {
    this.store.opened = true
  }

  hide(): void {
    this.store.opened = false
  }

  toggle(): void {
    this.store.opened = !this.store.opened
  }

  getViewPath(): string {
    return '/console/v1/view/'
  }
}

export default function():ISysConsoleModule{
  return ConsoleV1.getInstance()
}
